import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import Table from './table';

class TableBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    render() {
        const { isOpen } = this.props;
        const { tit, data } = this.props.content;

        return (
            <div className={styles.box}>
                {data
                    ? Object.keys(data).map((key, index) => (
                          <Table
                              key={index}
                              content={{
                                  tit,
                                  data: data && data[key],
                              }}
                              isOpen={isOpen}
                          />
                      ))
                    : [0, 1, 2, 3].map((key, index) => (
                          <Table
                              key={index}
                              content={{
                                  tit,
                                  data: {},
                              }}
                              isOpen={isOpen}
                          />
                      ))}
            </div>
        );
    }
}

export default errorBoundary(TableBox);
